
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

@Component
export default class DynamicComponent extends Vue {
  @Prop({ default: null }) blockInfo!: any;
  @Prop({ default: null }) blockDataInfo!: any;
  @Prop({ default: false }) showTop!: boolean;
  @Prop({ default: 0 }) topValue!: number;

  // 组件映射对象
  private componentBlockObj: any = {
    newsNoImg: () => import('./components/XcqNoImg.vue'), // 无图
    newsOneImg1: () => import('./components/XcqSingleImg.vue'), // 左文右图
    newsThreeImg: () => import('./components/XcqThreeImg.vue'), // 三图
    newsBigImg: () => import('./components/XcqBigAndMiddleImg.vue'), // 大图
    newsMidImg: () => import('./components/XcqBigAndMiddleImg.vue'), // 中图
    newsSmallImg: () => import('./components/XcqSamallImg.vue'), // 小图
    newsOnlyImg1: () => import('./components/XcqOnlyImgOne.vue'),
  };

  // 计算当前组件
  get currentComponent(): any {
    const showType =
      (this.blockDataInfo && this.blockDataInfo.showType) ||
      (this.blockInfo && this.blockInfo.showType);

    return this.componentBlockObj[showType] || null;
  }

  // 点击事件处理方法
  clickItem(item: any, info: any): void {
    // jumpFn(item);
    if (window.udid) {
      const data = {
        dt: 7,
        url: info.url,
      };
      window.openApp('mJump', data);
    } else {
      location.href = info.url;
    }
  }
}
